import LegalPage from './LegalPage';

export default function SMSCompliance() {
  return (
    <LegalPage
      pageKey="smsCompliance"
      testId="sms-compliance"
      extraFooterLinks={[
        { to: '/privacy', labelKey: 'privacy' },
        { to: '/terms', labelKey: 'terms' },
      ]}
    />
  );
}
